import { Lightbulb, MessageCircle, Plug, Shapes } from 'lucide-react'

import { cn } from '@/lib/utils'
import { useArtifactsLabel } from './agentName'

/** The surfaces the agent switches between. */
export enum AgentTab {
  CHAT = 'CHAT',
  IDEAS = 'IDEAS',
  ARTIFACTS = 'ARTIFACTS',
  CONNECT = 'CONNECT',
}

export const TAB_LABEL: Record<AgentTab, string> = {
  [AgentTab.CHAT]: 'Chat',
  [AgentTab.IDEAS]: 'Ideas',
  [AgentTab.ARTIFACTS]: 'Artifacts',
  [AgentTab.CONNECT]: 'Connect',
}

const ICONS = {
  [AgentTab.CHAT]: MessageCircle,
  [AgentTab.IDEAS]: Lightbulb,
  [AgentTab.ARTIFACTS]: Shapes,
  /** Fleet assistant adds a place to wire the fleet's other accounts in. */
  [AgentTab.CONNECT]: Plug,
}

const BASE_TABS = [AgentTab.CHAT, AgentTab.IDEAS, AgentTab.ARTIFACTS]

interface AgentTabBarProps {
  tab: AgentTab
  /** Omitted during sign-up, where the bar is chrome rather than navigation. */
  onSelect?: (tab: AgentTab) => void
  connect?: boolean
}

export function AgentTabBar({ tab, onSelect, connect }: AgentTabBarProps) {
  const tabs = connect ? [...BASE_TABS, AgentTab.CONNECT] : BASE_TABS
  const artifacts = useArtifactsLabel()

  return (
    <div className="border-ink-100 flex items-stretch border-t bg-white">
      {tabs.map((entry) => {
        const Icon = ICONS[entry]
        const active = entry === tab
        return (
          <button
            key={entry}
            type="button"
            onClick={onSelect && (() => onSelect(entry))}
            aria-current={active}
            className={cn(
              'flex flex-1 flex-col items-center gap-0.5 py-2 text-[10px]',
              active ? 'text-ink font-medium' : 'text-ink-400'
            )}
          >
            <Icon className={cn('size-4', active ? 'text-brand-700' : 'text-ink-300')} />
            {entry === AgentTab.ARTIFACTS ? (artifacts ?? TAB_LABEL[entry]) : TAB_LABEL[entry]}
          </button>
        )
      })}
    </div>
  )
}
